import { useEffect, useState } from "react";
import styles from "./styles.module.css";
import useMediaQuery from "../../app/common/hooks/useMediaQuery";
import { useNavigate } from "react-router-dom";
import { Button, Loader, Popup } from "semantic-ui-react";
import { ReactComponent as LogoSvg } from "../../assets/altlogo.svg";
import { ReactComponent as Logo2Svg } from "../../assets/altlogo2.svg";
import { ReactComponent as AltBankLogoSvg } from "../../assets/altbanklogo.svg";
import { ReactComponent as EnigmaSvg } from "../../assets/enigma.svg";
import { ReactComponent as UserSvg } from "../../assets/user.svg";
import { ReactComponent as DownIconSvg } from "../../assets/downicon.svg";
import { ReactComponent as PlaySvg } from "../../assets/play.svg";
import { ReactComponent as ScrollArrowSvg } from "../../assets/scrollarrow.svg";
import { ReactComponent as CBNLogoSvg } from "../../assets/CBNLOGO.svg";
import { ReactComponent as TABLogoSvg } from "../../assets/TABLOGO.svg";
import { useStore } from "../../app/stores/store";
import { observer } from "mobx-react-lite";
import agent from "../../app/api/agent";

const IndexVendorsPage = () => {
  const [checked, setChecked] = useState(false);
  const matches = useMediaQuery("(min-width: 800px)");
  const navigate = useNavigate();
  const { commonStore, userStore } = useStore();
  const { GetItem, loadingInitial, getVendors, storeList } = commonStore;
  const token: string | null = GetItem("jwt");
  const { logout } = userStore;
  const loggedInUser = () => {
    try {
      const data = window.localStorage.getItem("user");
      return agent.decryptResponse(data);
    } catch {
      return null;
    }
  };
  const scrollUp = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  const scrollDown = () => {
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  };

  const faq = process.env.REACT_APP_FAQ_URL;
  const returnPolicy = process.env.REACT_APP_RETURN_POLICY;
  const privacyPolicy = process.env.REACT_APP_PRIVACY_POLICY;
  const termsAndConditions = process.env.REACT_APP_T_AND_C;
  const paymentOptions = process.env.REACT_APP_PAYMENT_OPTIONS;
  const deliveryInformation = process.env.REACT_APP_DELIVERY_INFORMATION;
  const powerOptions = process.env.REACT_APP_POWER_OPTIONS;
  const aboutUs = process.env.REACT_APP_ABOUT;

const isHttpUrl = (value: string) => /^https?:\/\//i.test(value);
const isDataUrl = (value: string) => /^data:/i.test(value);


const detectImageMime = (base64: string): string => {
  const sig = base64.slice(0, 24);
  if (sig.startsWith("iVBORw0KGgo")) return "image/png";
  if (sig.startsWith("/9j/")) return "image/jpeg";
  if (sig.startsWith("R0lGOD")) return "image/gif";
  if (sig.startsWith("UklGR")) return "image/webp";
  // Reasonable default for product photos when the signature is unrecognized
  return "image/png";
};

const resolveImageSrc = (value?: string | null): string | undefined => {
  if (!value || value === null) return undefined;

  // Already a normal URL or a properly formed data URI — use as-is
  if (isHttpUrl(value) || isDataUrl(value)) return value;

  // Otherwise treat it as raw base64 and build the data URI ourselves
  const cleaned = value.replace(/\s/g, "");
  const mime = detectImageMime(cleaned);
  return `data:${mime};base64,${cleaned}`;
};


  useEffect(() => {
    getVendors();
    // console.log("vendors", storeList);
    // .catch();
  }, []);
  return (
    <>
      <div className={styles.origin}>
        <div className={styles.mainWrapper}>
          <div className={styles.page}>
            <div className={styles.navWrapper}>
              <div className={styles.nav}>
                <div
                  // type="checkbox"
                  className={`${styles.navcheck} ${checked && styles.checked}`}
                  // defaultChecked={false}
                  // checked={checked}
                />
                <div className={styles.navheader}>
                  <div className={styles.navtitle}>
                    {/* <img
                  src={altlogo}
                  style={{
                    width: matches ? "150px" : "150px",
                    cursor: "pointer",
                  }}
                  alt="logo"
                  onClick={() => navigate("/")}
                /> */}
                    <LogoSvg onClick={() => navigate("/")} />
                  </div>
                </div>
                <div
                  className={styles.navbtn}
                  onClick={() => setChecked(!checked)}
                >
                  <label htmlFor="navcheck">
                    <span></span>
                    <span></span>
                    <span></span>
                  </label>
                </div>

                <div className={styles.navlinks}>
                  <span>
                    {" "}
                    <div className={styles.flexCenter}>
                      <EnigmaSvg />
                      <span>Help</span>
                      <Popup
                        trigger={<DownIconSvg style={{ cursor: "pointer" }} />}
                        content={
                          <div className={styles.menu}>
                            <div
                              onClick={() => window.open(faq, "_blank")}
                              style={{ cursor: "pointer" }}
                            >
                              FAQs
                            </div>
                            <hr />
                            <div
                              style={{ cursor: "pointer" }}
                              onClick={() => scrollDown()}
                            >
                              Contact Us
                            </div>
                            <hr />
                            {returnPolicy && (
                              <div
                                style={{ cursor: "pointer" }}
                                onClick={() =>
                                  window.open(returnPolicy, "_blank")
                                }
                              >
                                Return Policy
                              </div>
                            )}
                          </div>
                        }
                        on="click"
                        position="bottom center"
                      />
                    </div>
                  </span>
                  <span>
                    {" "}
                    <div className={styles.flexCenter}>
                      <UserSvg />
                      <span
                        style={{
                          cursor: !token || token === null ? "pointer" : "",
                        }}
                        onClick={() =>
                          (!token || token === null) && navigate("/login")
                        }
                      >
                        {loggedInUser() ? "Account" : "Sign in"}
                      </span>
                      {token && matches && (
                        <Popup
                          trigger={
                            loggedInUser() && (
                              <DownIconSvg style={{ cursor: "pointer" }} />
                            )
                          }
                          header={`${
                            loggedInUser() && loggedInUser()!.firstName
                          } ${
                            loggedInUser() && loggedInUser().lastName !== null
                              ? loggedInUser().lastName
                              : ""
                          }`}
                          content={
                            <div className={styles.menu}>
                              <hr />
                              <div
                                onClick={() => navigate("/vendor/dashboard")}
                                style={{ cursor: "pointer" }}
                              >
                                Dashboard
                              </div>
                              <hr />
                              <div
                                style={{ cursor: "pointer" }}
                                onClick={() => logout()}
                              >
                                Log Out
                              </div>
                            </div>
                          }
                          on="click"
                          position="bottom center"
                        />
                      )}
                    </div>
                  </span>
                  {/* <span className={styles.next}>
                <Button
                  positive
                  className={styles.positive}
                  onClick={() => navigate("/")}
                >
                  <div className={styles.flexCenter}>
                    <div className={styles.flexCenter}>
                      <CartSvg />
                      <span>Cart</span>
                    </div>
                    <Label circular color={"green"}>
                      2
                    </Label>
                  </div>
                </Button>
              </span> */}
                </div>
              </div>
            </div>
            <div className={styles.bannerWrapper}>
              <div className={styles.banner}>
                <div className={styles.bannerInfo}>
                  <div>
                    <h2>Contribute to providing clean energy to Nigerians.</h2>
                    <h5>Start selling on AltPower now</h5>
                    <div className={styles.next}>
                      <Button
                        positive
                        className={styles.bannerPositive}
                        onClick={() => navigate("/register")}
                      >
                        <div className={styles.flexCenterBetween}>
                          <span>Get started</span>
                          <PlaySvg />
                        </div>
                      </Button>
                    </div>
                  </div>
                </div>
                <div className={styles.bannerImage}>
                  <div className={styles.engineer}></div>
                  <div className={styles.bolt}></div>
                </div>
              </div>
            </div>
            <div className={styles.storeList}>
              {loadingInitial === "loading" ? (
                <Loader active inline="centered" />
              ) : storeList && storeList.length > 0 ? (
                <div className={styles.ourVendors}>
                  <h2>Our Vendors</h2>
                  <div className={styles.vendorsList}>
                    {storeList.map((store, index) => {
                      const logoSrc = resolveImageSrc(store.storeLogo);
                      return (
                        <div
                          className={styles.vendorBox}
                          key={index}
                          onClick={() => navigate(`/vendors/${store.slug}`)}
                        >
                          {logoSrc ? (
                            <img src={logoSrc} alt="storelogo" />
                          ) : (
                            <LogoSvg />
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
          <div className={styles.footer}>
            <div className={styles.content}>
              <Logo2Svg />
              <div className={styles.footerlinks}>
                <div onClick={() => window.open(aboutUs, "_blank")}>
                  About Us
                </div>
                <div onClick={() => window.open(termsAndConditions, "_blank")}>
                  Terms & Conditions
                </div>
                <div onClick={() => navigate("/login")}>My Account</div>
              </div>
              <div className={styles.footerlinks}>
                <div onClick={() => window.open(deliveryInformation, "_blank")}>
                  Delivery Information
                </div>
                <div onClick={() => window.open(paymentOptions, "_blank")}>
                  Payment Options
                </div>
                <div onClick={() => window.open(powerOptions, "_blank")}>
                  Power As A Service
                </div>
              </div>
              <div className={styles.footerlinks}>
                <div onClick={() => window.open(privacyPolicy, "_blank")}>
                  Privacy Policy
                </div>
                <div
                  onClick={() => window.open(faq, "_blank")}
                  className={styles.sterlink}
                >
                  FAQ
                </div>
                <div onClick={() => window.open(returnPolicy, "_blank")}>
                  Return Policy
                </div>
              </div>
              <div className={styles.footerlinks}>
                <h5>02017000555</h5>
                <div
                  className={styles.emaillink}
                  onClick={() =>
                    window.open("mailto:service@altpower.ng", "_blank")
                  }
                >
                  service@altpower.ng
                </div>
                {/* <div className={styles.altbanklogo}>
                  <AltBankLogoSvg />
                </div> */}
              </div>
            </div>
            <div className={styles.scrollup} onClick={() => scrollUp()}>
              <div className={styles.arrowdown}>
                {" "}
                <ScrollArrowSvg />
              </div>
            </div>
            <div className={styles.copyright}>
              <span>
                Licensed by Cental Bank Of Nigeria <CBNLogoSvg />
              </span>
              <span>|</span>
              <span>Powered by</span>
              <span>
                <TABLogoSvg />
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default observer(IndexVendorsPage);
